document.addEventListener("DOMContentLoaded", () => {
  const accordions = document.querySelectorAll("[accordion]");

  accordions.forEach((accordion) => {
    accordion.addEventListener("click", () => {
      if (accordion.classList.contains("active")) {
        accordion.classList.remove("active");
      } else {
        accordions.forEach((a) => a.classList.remove("active"));
        accordion.classList.add("active");
      }
    });
  });
});
